import moment from 'moment';
import { getValueByPath } from './getValueByPath';

export const sortTypes = {
  string: 'string',
  number: 'number',
  date: 'date',
};

const toDoNothing = (arr, order) =>
  !arr || !Array.isArray(arr) || arr.length === 0 || !order;

const getValues = (a, b, orderBy) => {
  const aVal = orderBy ? getValueByPath(a, orderBy) : a;
  const bVal = orderBy ? getValueByPath(b, orderBy) : b;

  return { aVal, bVal };
};

const sortDates = (a, b) => {
  if (a === undefined) return 1;
  if (b === undefined) return -1;
  return a.diff(b);
};

export const sortAlphabetically = (arr, order, orderBy) => {
  if (toDoNothing(arr, order)) {
    return arr;
  }

  return arr.slice().sort((a, b) => {
    const { aVal, bVal } = getValues(a, b, orderBy);

    const start = aVal || '';
    const end = bVal || '';

    return order === 'asc'
      ? start.localeCompare(end)
      : end.localeCompare(start);
  });
};

export const sortByDate = (arr, order, orderBy) => {
  if (toDoNothing(arr, order)) {
    return arr;
  }

  return arr.slice().sort((a, b) => {
    const { aVal, bVal } = getValues(a, b, orderBy);

    const start = aVal ? moment(aVal) : undefined;
    const end = bVal ? moment(bVal) : undefined;

    return order === 'asc' ? sortDates(start, end) : sortDates(end, start);
  });
};

export const sortNumerically = (arr, order, orderBy) => {
  if (toDoNothing(arr, order)) {
    return arr;
  }

  return arr.slice().sort((a, b) => {
    const { aVal, bVal } = getValues(a, b, orderBy);

    const aValNum = Number(aVal);
    const bValNum = Number(bVal);

    const start = isNaN(aValNum) ? 0 : aValNum;
    const end = isNaN(bValNum) ? 0 : bValNum;

    return order === 'asc' ? start - end : end - start;
  });
};

export const stableSort = ({ arr, order, orderBy, sortType }) => {
  let newArr = arr;

  switch (sortType) {
    case sortTypes.string:
      newArr = sortAlphabetically(arr, order, orderBy);
      break;
    case sortTypes.number:
      newArr = sortNumerically(arr, order, orderBy);
      break;
    case sortTypes.date:
      newArr = sortByDate(arr, order, orderBy);
      break;
  }

  return newArr;
};
